import { render, staticRenderFns } from "./Comprobacion.vue?vue&type=template&id=a4c59158&scoped=true"
import script from "./Comprobacion.vue?vue&type=script&lang=js"
export * from "./Comprobacion.vue?vue&type=script&lang=js"
import style0 from "./Comprobacion.vue?vue&type=style&index=0&id=a4c59158&prod&scoped=true&lang=css"
import style1 from "./Comprobacion.vue?vue&type=style&index=1&id=a4c59158&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c59158",
  null
  
)

export default component.exports